export default function(data) {
  const self = this;
  self.plans = ko.observableArray([]);
  self.selectedPlan = ko.observable();
  self.yearlyPlan = ko.mapping.fromJS(data.yearly_plan);
  self.monthlyPlan = ko.mapping.fromJS(data.monthly_plan);
  self.paymentType = ko.observable(self.monthlyPlan.data.id());
  self.currentSplitView = ko.observable();

  self.selectPlan = function(plan) {
    self.paymentType(plan.data.id());
    self.selectedPlan(plan);
  };

  self.selectYearly = function() {
    self.selectPlan(self.yearlyPlan);
  };

  self.selectMonthly = function() {
    self.selectPlan(self.monthlyPlan);
  };

  self.planCost = ko.computed(function() {
    if (self.selectedPlan()) {
      return self.selectedPlan().cost() + '/' + self.selectedPlan().data.interval();
    }
    return '';
  });

  self.upgrade = function(vm, evt) {
    const path = Kadenze.Routes.shop_add_item_to_cart_path('plan','') + self.paymentType();
    const request = new Kadenze.AjaxRequest({
      url: path,
      type: 'POST'
    });
    request.done(function (data) {
      if(data.next_url){
        window.location.replace(data.next_url);
      } else {
        new Kadenze.Notice.success({message: data.message});
      }
    });
    request.fail(function (data) {
      console.log(data);
      new Kadenze.Notice.error({message: data.responseJSON.message});
    });
  };

  self.cancel = function() {

  };

  self.bindData = function(data) {
    const mapped = ko.mapping.fromJS(data);
    self.plans(mapped.plans());
    self.selectPlan(self.monthlyPlan);
  };

  const __construct = function(that) {
    console.log('Initializing ShopPlanSelectionViewModel - webpack version');
    that.bindData(data);
    Kadenze.WebApp.onHjLoaded(() => {
      hj('vpv', `${Kadenze.Routes.shop_plans_path()}/${s.slugify(self.currentSplitView())}`);
    });
  }(this);
}

